import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth';
import { auth } from './firebase-config';
import styles from './Login.module.css'; // Import CSS module for styling

function friendlyAuthError(err) {
    switch (err?.code) {
        case 'auth/invalid-credential':
        case 'auth/wrong-password':
        case 'auth/user-not-found':
            return 'Incorrect email or password.';
        case 'auth/invalid-email':
            return 'Please enter a valid email address.';
        case 'auth/too-many-requests':
            return 'Too many attempts. Please wait a moment and try again.';
        case 'auth/network-request-failed':
            return 'Network error. Check your connection and try again.';
        case 'auth/user-disabled':
            return 'This account has been disabled.';
        default:
            return 'Login failed. Please try again.';
    }
}

const Login = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const [resetSent, setResetSent] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    const onForgotPassword = async () => {
        setError(null);
        setResetSent(false);
        if (!email) {
            setError('Enter your email address first.');
            return;
        }
        try {
            await sendPasswordResetEmail(auth, email);
            setResetSent(true);
        } catch (err) {
            setError(friendlyAuthError(err));
        }
    };

    const onSubmit = async (e) => {
        e.preventDefault();
        if (submitting) return;
        setError(null);
        setSubmitting(true);
        try {
            await signInWithEmailAndPassword(auth, email.trim(), password);
            navigate('/', { replace: true });
        } catch (err) {
            setError(friendlyAuthError(err));
            setSubmitting(false);
        }
    }

    return (
        <div>
        <main className={styles.container}>
            <section className={styles.section}>
                <div className={styles.formWrapper}>
                    <h1>Log in to your account</h1>
                    {error && <p className={styles.error}>{error}</p>}
                    {resetSent && <p className={styles.success}>Password reset email sent! Check your inbox/spam/junk.</p>}
                    <form className={styles.form}>
                        <div className={styles.formGroup}>
                            <label htmlFor="email">Email address</label>
                            <input
                                type="email"
                                id="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}  
                                required
                            />
                        </div>
                        <div className={styles.formGroup}>
                            <label htmlFor="password">Password</label>
                            <input
                                type="password"
                                id="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)} 
                                required
                            />
                        </div>
                        <button
                            type="submit"
                            onClick={onSubmit}
                            disabled={submitting}
                            className={styles.custombutton}
                        >
                            {submitting ? 'Logging in…' : 'Log in'}
                        </button>
                        <button
                            type="button"
                            onClick={onForgotPassword}
                            className={styles.forgotButton}
                        >
                            Forgot password?
                        </button>
                    </form>
                    <p>Don't have an account? <NavLink to="/signup">Sign up</NavLink></p>
                </div>
            </section>
        </main>        </div>

    );
}

export default Login;
